import styles from './Happen.module.scss'

import React from 'react'

import { Container, FlexColumn } from 'components/common/Containers'
import { H2 } from 'components/common/Texts/H2/H2'
import { HappenRow } from './components/HappenRow/HappenRow'
import classNames from 'classnames'

export type HappenDataElement = {
  key: number
  imageSrc: string
  imageAlt: string
  title: string
  desc: string
}
interface Props {
  titleClassName?: string
  contentClassName?: string
  data: HappenDataElement[]
  title: string
  conatinerClassName?: string
}

const Happen: React.FC<Props> = ({
  data,
  title,
  titleClassName,
  contentClassName,
  conatinerClassName,
}) => {
  return (
    <Container className={conatinerClassName}>
      <H2 className={classNames(styles.head, titleClassName)}>{title}</H2>
      <FlexColumn
        gap="2rem"
        className={classNames(styles.contentWrap, contentClassName)}
      >
        {data.map((row) => (
          <HappenRow key={row.key} {...row} />
        ))}
      </FlexColumn>
    </Container>
  )
}

export default Happen
